import { Editor, Element } from "slate";

import ElementType from "../../../type/slate/ElementType";

const withResourceLinks = (editor: Editor): Editor => {
  const { isInline, isVoid } = editor;

  editor.isInline = (element: Element) => {
    if (Element.isElementType(element, ElementType.RESOURCE_LINK)) {
      return false;
    }

    return isInline(element);
  };

  editor.isVoid = (element: Element) => {
    return Element.isElementType(element, ElementType.RESOURCE_LINK) || isVoid(element);
  };

  return editor;
};

export default withResourceLinks;
